import * as ss from 'superstruct';

/**
 * Leap (JobProgress) input streams.  They read through a Leap connection,
 * whose API key is a static bearer token generated at Settings -> Developer
 * in Leap.  Only admin Leap users can generate one.
 */

/**
 * Leap division ids.  Leap assigns divisions to jobs, not customers, so only
 * the job-based streams can be filtered; leads cannot.  Absent or empty is no
 * filter.
 */
const LeapDivisionIds = ss.optional(ss.array(ss.min(ss.integer(), 1)));

/**
 * Both lists may be set: a job is kept when it is in `includeDivisionIds` (if
 * any are listed) and not in `excludeDivisionIds`.  A job with no division
 * never matches an include list and is never excluded.
 */
export const LeapDivisionFilter = ss.type({
  includeDivisionIds: LeapDivisionIds,
  excludeDivisionIds: LeapDivisionIds,
});

export type LeapDivisionFilter = ss.Infer<typeof LeapDivisionFilter>;

export const LeapLeadInputStreamSource = ss.type({
  name: ss.literal('leap-lead'),
});

export type LeapLeadInputStreamSource = ss.Infer<
  typeof LeapLeadInputStreamSource
>;

/**
 * Include-only: Leap filters /appointments by division itself but offers no
 * exclusion.
 */
export const LeapAppointmentSetInputStreamSource = ss.type({
  name: ss.literal('leap-appointment-set'),
  includeDivisionIds: LeapDivisionIds,
});

export type LeapAppointmentSetInputStreamSource = ss.Infer<
  typeof LeapAppointmentSetInputStreamSource
>;

export const LeapJobCreatedInputStreamSource = ss.assign(
  ss.type({
    name: ss.literal('leap-job-created'),
  }),
  LeapDivisionFilter,
);

export type LeapJobCreatedInputStreamSource = ss.Infer<
  typeof LeapJobCreatedInputStreamSource
>;

export const LeapJobAwardedInputStreamSource = ss.assign(
  ss.type({
    name: ss.literal('leap-job-awarded'),
  }),
  LeapDivisionFilter,
);

export type LeapJobAwardedInputStreamSource = ss.Infer<
  typeof LeapJobAwardedInputStreamSource
>;
